// Shared legal/company constants — update these as your business details firm up.
export const COMPANY_NAME = "Rodeo Pilot";
export const JURISDICTION = "Province of Alberta, Canada";
export const LEGAL_EMAIL = "support@rodeopilot.com";
export const LAST_UPDATED = "June 2026";
